import { tableState, tableMutations, tableActions } from "@tt/vue-components";
import entityService from "@/services/EntityService";
import EnvProvider from "@tt/vue-environment";

const locationsList = {
  namespaced: true,
  state: {
    ...tableState,
    search: [
      { column: 'props[]', value: 'id' },
      { column: 'props[]', value: '@id' },
      { column: 'props[]', value: 'code' },
      { column: 'props[]', value: 'name' },
    ]
  },
  mutations: {
    ...tableMutations,
  },
  actions: {
    ...tableActions,
    load(context, refresh = false) {
      if (refresh || context.state.items?.length === 0) {
        context.commit("SET_LOADING", true);
        const params = { pagination: { page: 1, itemsPerPage: 999}, sorting: { sortBy: ["name"], sortDesc: [false] }, search: context.state.search };

        if (!EnvProvider.value("ENTITY_API_URL")) {
          console.error("ENTITY_API_URL is not set in environment variables.");
          context.commit("SET_LOADING", false);
          return;
        }

        entityService.locations.list(params)
          .then(json => {
            context.commit("SET_ITEMS", json);

            // preselect
            if (context.state.source) {
              json.items.forEach(source => {
                if (source.id === context.state.source.id) {
                  context.dispatch("selectSource", source);
                }
              });
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            context.commit("SET_LOADING", false);
          });
      }
    },
  },
  getters: {
    getLocationByCode: (state) => (code) => {
      return state.items.find(item => item.code === code)
    }
  }
};

export default locationsList;
